import { Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ProspectService } from '../../services/prospect.service';
// import * as moment from 'moment';
import moment from 'moment';
import { PtlWindowLocationService } from '@ptl/global-components';
import { MatDialog } from '@angular/material/dialog';
import { GoToMarketplaceModalComponent } from './go-to-marketplace-modal/go-to-marketplace-modal.component';
import { environment } from 'src/environments/environment';
import { NgRedux } from '@ptl/angular-redux-store';
import { setCurrentProspectId } from '../../reducers/eligibility.reducer';
import { StateStructure } from '@ptl/state';
import { LINE_OF_BUSINESS_ENUM, LOGIN_INFO_REDUCER_NAME, UserInfoStateStructure } from '@ptl/account-management';
import { BrandingConfigurationService } from '@ptl/brand';
import { CommonUtilityService } from 'src/app/shared/utility-services/common-utility.service';
import { MoreInfoModalComponent } from './more-info-modal/more-info-modal.component';
import { ConsumerApplicationStatusProspect } from '../../interfaces/prospect.consumer-application-status.interface';
import { Prospect, PROSPECT_APPLICATION_STATUSES, UpdateProspectStatusRequest } from '../../interfaces/prospect.interface';
import { applicationStatusND, applicationStatusWY, oldTeamsiteContent_PENNSYLVANIACOUNTYLISTNOONXPRODUCTS } from './caps.config';
import { ContentStorageService } from '@ptl/global-components';
import { Subscription } from 'rxjs';
import { Prospect as ProducerRetrievedProspect } from '../../interfaces/on-exchange-prospects-retrieval.producer.response.interface';
import { setTotalLength } from '../../reducers/producer-prospect-paginator.reducer';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { GlobalShadowStyleDirective } from '@ptl/global-components';

const CONSUMER_APPLICATION_STATUS_CONTENT = 'CONSUMER_APPLICATION_STATUS_CONTENT';
enum CONSUMER_APPLICATION_STATUS_CONTENT_KEYS {
  PAYMENT_LINK = 'PAYMENT_LINK',
  IS_EBILL_ACTIVE = 'IS_EBILL_ACTIVE'
}
/**
 * Legacy:  upon login, prospect data is retrieved and user is redirected to this page ( based on ASP and SEP-status)
 * ShopX:  will send users to this page to begin with and run the pre-redirect logic here ( for now )
 */
@Component({
    selector: 'app-consumer-application-status',
    templateUrl: './consumer-application-status.component.html',
    styleUrls: ['./consumer-application-status.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false
})

export class ConsumerApplicationStatusComponent extends GlobalShadowStyleDirective implements OnInit {

  forceValues = false;

  @Input() goToHealthSherpa: 'true' | 'false';
  get _goToHealthSherpa() { return this.goToHealthSherpa === 'true'; }
  @Input() enableOnxSales: 'true' | 'false';
  get _enableOnxSales() { return this.enableOnxSales === 'true'; }

  @Input() selectedMarket: LINE_OF_BUSINESS_ENUM;

  @Input() healthSherpaUrl: string;
  @Input() eligibilityUrl: string;
  @Input() enrollUrl: string;
  @Input() paymentUrl: string;
  @Input() summaryUrl: string;
  @Input() shopLandingPageUrl: string; // Build your family

  @ViewChild('ssoHandlerWrapper', { static: true }) ssoHandlerWrapper: ElementRef;

  oldTeamsiteContent_PENNSYLVANIACOUNTYLISTNOONXPRODUCTS = oldTeamsiteContent_PENNSYLVANIACOUNTYLISTNOONXPRODUCTS;
  applicationStatusContent: any;

  formattedProspectArray: ConsumerApplicationStatusProspect[] = [];

  isBeginNewProspectFlow: boolean;

  /** Links */
  paymentLink: string;
  eBillOn: boolean;

  /** onExchange stuff crammed here to avoid AMS deploy */
  contentStorageSubscription: Subscription;
  isOnExchangeExperience: boolean;
  onExchangeProspects: ProducerRetrievedProspect[];
  isProducer: boolean;
  onExchangeApps: {
    inProgressApps: ProducerRetrievedProspect[];
    completedApps: ProducerRetrievedProspect[];
    expiredApps: ProducerRetrievedProspect[];
    emailedApps: ProducerRetrievedProspect[];
    archivedApps: ProducerRetrievedProspect[];
  } = {
      inProgressApps: null,
      completedApps: null,
      expiredApps: null,
      emailedApps: null,
      archivedApps: null
    };
  displayOnx: boolean; // try to trick ngIf into refreshing stuff
  applicationStatuses = [
    { status: 'IN-PROGRESS', displayContent: 'IN-PROGRESS' },
    { status: 'COMPLETED', displayContent: 'COMPLETED' },
    { status: 'EXPIRED', displayContent: 'EXPIRED' },
    // { status: 'EMAILED', displayContent: 'EMAILED' },
    // { status: 'ARCHIVED', displayContent: 'ARCHIVED' }
  ];
  applicationStatus = 'IN-PROGRESS';
  showLoadingIndicator: boolean;

  constructor(
    private prospectService: ProspectService,
    private windowLocationService: PtlWindowLocationService,
    private matDialog: MatDialog,
    private ngRedux: NgRedux<StateStructure>,
    private brandService: BrandingConfigurationService,
    private commonUtilityService: CommonUtilityService,
    private contentStorage: ContentStorageService,
    private reducerUtilityService: ReducerUtilityService
  ) { 
    super();
  }

  trackByIndex(index: number, prospect: ProducerRetrievedProspect) {
    return index;
  }

  switchResponseStatus(responseType: 'IN-PROGRESS' | 'COMPLETED' | 'EXPIRED' | 'EMAILED' | 'ARCHIVED') {
    /** try to trigger view updates */
    this.displayOnx = false;
    switch (responseType) {
      case 'IN-PROGRESS': this.onExchangeProspects = this.onExchangeApps.inProgressApps; break;
      case 'COMPLETED': this.onExchangeProspects = this.onExchangeApps.completedApps; break;
      case 'EXPIRED': this.onExchangeProspects = this.onExchangeApps.expiredApps; break;
      case 'EMAILED': this.onExchangeProspects = this.onExchangeApps.emailedApps; break;
      case 'ARCHIVED': this.onExchangeProspects = this.onExchangeApps.archivedApps; break;
    }
    this.ngRedux.dispatch(setTotalLength(this.onExchangeProspects.length));
    this.displayOnx = true;
  }

  async ngOnInit(): Promise<void> {
    this.contentStorage.contentChanged$.subscribe(async () => {
      const consumerApplicationStatusContent = this.contentStorage.getContentMap(CONSUMER_APPLICATION_STATUS_CONTENT) as Map<any, any>;

      if (consumerApplicationStatusContent?.size > 0) {
        this.eBillOn = consumerApplicationStatusContent.get(CONSUMER_APPLICATION_STATUS_CONTENT_KEYS.IS_EBILL_ACTIVE) === 'true';
        this.paymentLink = consumerApplicationStatusContent.get(CONSUMER_APPLICATION_STATUS_CONTENT_KEYS.PAYMENT_LINK) || '/beta/on-exchange/enroll/payment';
      }
    });

    this.isProducer = this.commonUtilityService.isAgent();

    if (this.isProducer) {
      this.fetchStatusForProducer();
    } else {
      this.fetchStatusForProspect();
    }
  }

  async fetchStatusForProducer(statusType:
    'IN-PROGRESS'
    | 'COMPLETED'
    | 'EXPIRED'
    | 'EMAILED' = 'IN-PROGRESS'
  ) {
    this.showLoadingIndicator = true;
    this.onExchangeApps.inProgressApps = await this.prospectService.getProspectListProducer(this.selectedMarket, 'IN-PROGRESS');
    this.onExchangeApps.completedApps = await this.prospectService.getProspectListProducer(this.selectedMarket, 'COMPLETED');
    this.onExchangeApps.expiredApps = await this.prospectService.getProspectListProducer(this.selectedMarket, 'EXPIRED');
    this.onExchangeApps.emailedApps = await this.prospectService.getProspectListProducer(this.selectedMarket, 'EMAILED');
    this.switchResponseStatus(statusType);
    this.showLoadingIndicator = false;
  }

  async fetchStatusForProspect() {

    let curBrandCode = this.brandService.getCurrentBrand().cookieBrandCode?.toUpperCase();
    if (curBrandCode === 'NDBCBS') {
      this.applicationStatusContent = applicationStatusND;
    }
    if (curBrandCode === 'WYBCBS') {
      this.applicationStatusContent = applicationStatusWY;
    }

    /** Get Prospect or Create Prospect ( post login ) */
    await this.prospectService.parseServiceParams();

    const prospects = await this.prospectService.createProspectIfDoesNotExist();

    await this.prospectService.configureBrandingFromProspectResponse(prospects[0]);

    prospects.forEach(prospect => {
      const formattedProspect: ConsumerApplicationStatusProspect = JSON.parse(
        JSON.stringify(prospect)
      );

      formattedProspect.dataForTemplate = {
        effectiveDateFlag: prospect.status.id >= 9 && prospect.status.id !== 10,
        formattedTime: moment(prospect.status.timestamp).format(
          'MMMM DD, YYYY'
        ),
        formatEffectiveDate: prospect.status.effectiveDate
          ? moment(prospect.status.effectiveDate).format('MMMM DD, YYYY')
          : null,
        statusDetails: this.retrieveStatusDetail(formattedProspect),
        isApprovedForSale: this._enableOnxSales
      };

      /** @TODO do we set zip upon login such that this wouldn't matter? Are we using shopping brand? Does shopping brand ever different from address brand? */
      // actor.setBrand(formattedProspect.shoppingInfo.brand, "true");

      this.formattedProspectArray.push(formattedProspect);
    });
  }

  /** Button show/hide and some content overrides here ( this is old pattern ) */
  retrieveStatusDetail(prospect: ConsumerApplicationStatusProspect) {
    let config: any = {};

    this.applicationStatusContent.statuses.forEach(statusItem => {
      if (statusItem.id === prospect.status.id) {
        config = statusItem;

        if (statusItem.id === 5) {
          config.details += statusItem.extraContent;
        }

        if (this._goToHealthSherpa) {
          config.buttons.goToMarketplace = false;
          config.buttons.goToHealthSherpa = true;
        }
      }
    });

    return config;
  }

  buttonActions(prospect: ConsumerApplicationStatusProspect) {

    const sendToMarketPlace = () => {
      let countyExcludedFromONX = false;

      const countyOnPrimaryProspect = this.formattedProspectArray[0].shoppingInfo.county;
      if (countyOnPrimaryProspect && environment) {
        if (
          this.oldTeamsiteContent_PENNSYLVANIACOUNTYLISTNOONXPRODUCTS.displayCountyName &&
          this.oldTeamsiteContent_PENNSYLVANIACOUNTYLISTNOONXPRODUCTS.displayingWarning &&
          this.oldTeamsiteContent_PENNSYLVANIACOUNTYLISTNOONXPRODUCTS.counties.find(c => {
            return c.toUpperCase() === countyOnPrimaryProspect.toUpperCase();
          })
        ) {
          countyExcludedFromONX = true;
        }
      }

      this.matDialog.open(GoToMarketplaceModalComponent, {
        width: '50vw',
        height: '80vh',
        disableClose: false,
        data: {
          prospects: this.formattedProspectArray as Prospect[],
          selectedProspect: prospect as Prospect,
          countyExcludedFromONX
        }
      });
    };

    return {
      shopHighmark: async () => {

        const formData: UpdateProspectStatusRequest = new UpdateProspectStatusRequest(
          prospect as Prospect,
          PROSPECT_APPLICATION_STATUSES.SAVED_QUOTES_SHOP_DIRECTLY_HIGHMARK
        );

        const updateProspectStatusResponse
          = await this.prospectService.updateProspectStatus(formData);

        this.windowLocationService.goToUrl(this.shopLandingPageUrl);

      },
      continueToMarketplace: sendToMarketPlace,
      printSummary: () => {
        /** @TODO */
      },
      makePayment: () => {
        this.ngRedux.dispatch(setCurrentProspectId(prospect.prospectId));
        this.windowLocationService.goToUrl(`${this.paymentLink}`);
      },
      goToMarketplace: sendToMarketPlace,
      goToHealthSherpa: () => {
        this.windowLocationService.goToUrl(this.healthSherpaUrl);
      },
      viewResults: () => {
        this.ngRedux.dispatch(setCurrentProspectId(prospect.prospectId));
        this.windowLocationService.goToUrl(`${this.eligibilityUrl}`);
      },
      moreInfo: (paymentModalContent: { header: string, body: string }) => {
        this.matDialog.open(MoreInfoModalComponent, {
          width: '50vw',
          disableClose: true,
          data: {
            header: paymentModalContent.header,
            body: paymentModalContent.body
          }
        });
      },
      expire: async () => {
        const userInfo: UserInfoStateStructure = this.reducerUtilityService.getApplicationStates()[LOGIN_INFO_REDUCER_NAME];

        await this.prospectService.updateProspectStatusAsProducer(
          new UpdateProspectStatusRequest(
            prospect,
            { id: 15 },
            {
              agencyId: userInfo.userInfo.agencyInfo.selectedAgencies[this.selectedMarket].agencyId,
              npn: userInfo.userInfo.npnNo
            }
          )
        );
        this.fetchStatusForProducer('EXPIRED');
      }
    };
  }

  /** PRODUCER RELATED FUNCTIONALITY */
  beginNewProspectFlow() {
    this.isBeginNewProspectFlow = true;
  }

  endNewProspect() {
    this.isBeginNewProspectFlow = false;
  }

}
